import LoadMore from "./LoadMore"

export interface Props {
  isDisabled: boolean
  loading: boolean
  onClick: () => void
}

export interface ComponentProps extends Props {}

export default LoadMore
